import React, { useState } from 'react';
import { Button } from 'antd';

import { FormattedMessage } from '../../util/reactIntl';
import TellNetworkModal from './TellNetworkModal';

/**
 * "Tell your consultants" on a customer's job, for a supplier who manages its network: the supplier's
 * own Linked consultants the job fits, with the customer's name left out unless the supplier shows it.
 * The server decides whether the supplier can see the job and which consultants can.
 */
const TellConsultantsButton = ({ listingId, title }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <FormattedMessage id="TellNetworkModal.consultantsMenu" />
      </Button>
      {open ? (
        <TellNetworkModal
          open
          posting={{ id: listingId, title, listingType: 'job_listing' }}
          events={['jobToConsultants']}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
};

export default TellConsultantsButton;
